export default function (name, opts) {
  const widgetName = name;
  const widgetOpts = opts;

  const linkedImages = false;
  const linkNewTab = false;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: linkedImages ? ['all'] : [''],
    hasImages: true,
    lazyLoadImages: true,
    textOverImage: true,
    imageIsBackground: false,
    maxItemsVisible: 10,
    itemsPerPanel: 1,
    buyNowButton: false,
    moreButton: false,
    showDescription: false,
    cardWidgetLoaded: function (data) {
      const widgetData = data.items;
      $widget.find('.card-content').remove();

      if (widgetData.length <= 0) {
        $widget.remove();

        $('.tier-four').remove();
      } else {
        changeFormatCards(widgetData);
        $('.tier-four').css('opacity', '1');
      }
    },
  });

  function changeFormatCards(widgetData) {
    $widget.find('.card-widget-item').each(function (x) {
      const { URL } = widgetData[x];
      const $card = $(this);

      if (!URL) {
        $card.removeAttr('href');
      }
      if (!linkNewTab) {
        $card.removeAttr('target');
      }
      if (linkedImages) {
        $card.addClass('linked-images');
      }
    });
  }
}
